import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'creationDate', pure: true})
export class CreationDatePipe implements PipeTransform {

  transform(dateStr: string | Date): string {
    moment.locale('en')
    const date = moment(dateStr, 'YYYY-MM-DDTHH:mm:ssZ', false);
    const duration = moment.duration(moment().utc().diff(date));
    const minutes = duration.asMinutes();
    if (minutes < 1) {
      return 'Just now';
    }
    const hours = duration.asHours();
    if (hours < 1) {
      return Math.round(duration.asMinutes()) + ` ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    }
    if (hours < 24) {
      return Math.round(hours) + ` ${hours === 1 ? 'hour' : 'hours'} ago`;
    }
    // Else show full date
    const years = duration.asYears();
    const dateFormat = years < 1 ? 'MMMM D' : 'MMMM D YYYY';
    return `${date.format(dateFormat)} at ${date.format('hh:mm A')}`
  }

}
